function imgZoom() {
    document.querySelectorAll('.zoomModal').forEach(function (element) {
        element.addEventListener('click', function () {
            const imgSrc = this.querySelector('img').getAttribute('src');
            document.querySelector('.imagepreview').setAttribute('src', imgSrc);
        });
    });
}

export default imgZoom;
